import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

const YearsList = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark {
        edges {
          node {
            frontmatter {
              date(formatString: "YYYY")
            }
          }
        }
      }
    }
  `)

  // Extract an array of unique years from the markdown article frontmatter
  const years = Array.from(
    new Set(
      data.allMarkdownRemark.edges.map(({ node }) => node.frontmatter.date)
    )
  )

  // Sort the years in descending order
  years.sort((a, b) => b - a)

  // Render a list of the unique years
  return (
    <div className="row mt-2 mt-sm-0">
        <h2 className="titre">Archives</h2>
        <div className="col-12">
            <ul>
            {years.map(year => (
                <li key={year}><Link to={`/archives/date/${year}`}>{year}</Link></li>
            ))}
            </ul>
        </div>
    </div>
  )
}

export default YearsList